import ErrorAlert from "components/ErrorAlert";
import ReservationTimer from "components/ReservationTimer";
import { BOOKINK_LINK, BOOKINK_SESSION } from "constants";
import { useEffect } from "react";
import { confirmAlert } from "react-confirm-alert";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { resetReservationstate, updateReservationstate } from "store/reducer/ticketReservationSlice";
import tikitly_logo from "../../assets/icon/tikitly_logo.png";
import { useTranslation } from "react-i18next";
import logger from "utils/logger";

export default function TwFooter(props) {
  const { t } = useTranslation()
  const BOOKINKLINK = window.localStorage.getItem(BOOKINK_LINK);
  const { children, isShowReservation = false } = props
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const ticketReservationstate = useSelector((state) => state.TicketReservation);

  const sessionTimeOutCall = () => {
    dispatch(resetReservationstate());
    confirmAlert({
      customUI: ({ onClose }) => {
        return (
          <ErrorAlert
            error={t("error.timeOutDetail")}
            serverError={t("error.timeOutTitle")}
            onClose={() => {
              onClose();
              const currentURL = window.location.href;
              const pathname = window.location.pathname;
              logger.log("BOOKINKLINK", BOOKINKLINK);
              logger.log("pathname", pathname);

              if (!BOOKINKLINK || BOOKINKLINK == null || BOOKINKLINK === "null") {
                window.location.replace("/");
                // navigate(`/`, { replace: true });
              } else if (BOOKINKLINK && BOOKINKLINK !== "") {
                if (BOOKINKLINK == pathname) {
                  window.location.reload();
                } else {
                  window.location.replace(BOOKINKLINK);
                  // navigate(`${BOOKINKLINK}`, { replace: true });
                }
              }
            }}
          />
        );
      },
      closeOnEscape: false,
      closeOnClickOutside: false,
    });
  }
  useEffect(() => {
    // console.log("ticketReservationstate", ticketReservationstate);

    let bookink_session = window.localStorage.getItem(`${BOOKINK_SESSION}`);

    if (bookink_session) {
      bookink_session = JSON.parse(bookink_session)
      // console.log("bookink_session", bookink_session);
      if (ticketReservationstate.reservationId && ticketReservationstate.reservationId === "no"
        && bookink_session.reservationId && bookink_session.reservationId !== "no") {
        dispatch(updateReservationstate({ ...Object.keys(bookink_session).length > 0 ? bookink_session : {} }));
      }
    }
  }, [ticketReservationstate]);

  return (
    <div className="flex flex-col border-0 border-t-0 border-gray-300 shadow-top">
      <div className="flex flex-col gap-3 bg-white">
        {children}
      </div>
      {isShowReservation && ticketReservationstate
        && ticketReservationstate.reservationId && ticketReservationstate.reservationId != "no"
        && ticketReservationstate.expiryIn && ticketReservationstate.expiryIn > 0
        && (<ReservationTimer
          currentTime={Date.now()}
          expiryTime={ticketReservationstate.expiryOn}
          logout={() => {
            // your logout logic here
            logger.log("Session expired. Logging out...");
            sessionTimeOutCall();
            // For example:
            // localStorage.clear();
            // navigate("/login");
          }}
        />)}
      <div className="py-5 px-3 w-full flex items-center gap-2 text-left text-sm">
        {t("common.poweredBy")}
        <a href="https://tikitly.com" rel="noreferrer" target="_blank">
          <img alt="" src={tikitly_logo} className="w-20" />
        </a>
      </div>
    </div>
  );
}
